import * as React from "react";
import { withRouter } from "react-router-dom";
import { NextBestAction } from "@origin-digital/personalisation";
import { BASE_PATH } from "../../helpers/router.helper";

export interface IRouterHistory {
  push: (path) => any;
}
export interface ICustomisedNBAProps {
  history: IRouterHistory;
  content: Record<string, string>;
}

// A wrapper over the NextBestAction component to provide customisation that is
// specific to H&S app
// 1. Removing the borders around the card
// 2. Achieve native compatibility by intercepting link clicks to use react-router when linking within the app
export class CustomisedNBA extends React.Component<ICustomisedNBAProps> {
  handleClick = (event) => {
    const parent = event.target.parentElement;
    if (
      parent &&
      parent.getAttribute("data-id") === "next-best-action-button"
    ) {
      const href = parent.getAttribute("href");
      if (href.indexOf(BASE_PATH) === 0) {
        this.props.history.push(href);
        event.preventDefault();
      }
    }
  };

  handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.keyCode == 13) {
      this.handleClick(event);
    }
  };

  render() {
    return (
      <div onClick={this.handleClick} onKeyDown={this.handleKeyDown}>
        <NextBestAction content={this.props.content as any} />
      </div>
    );
  }
}

export const HSNextBestAction = withRouter(CustomisedNBA);
